export default "__VITE_ASSET__CfAQmTyh__"